// extracted by mini-css-extract-plugin
module.exports = {"phoneBlockWrapper":"PhoneNumberBlock_phoneBlockWrapper__1fhqh"};